import Vue from "vue"
// REMINDER - Global route mixins are more trouble than they are worth
//            Phase this out slowly
Vue.mixin({
  methods: {
    goHome() {
      this.$router.push({ name: process.env.VUE_APP_RT_HOME }).then().catch(()=>{})
    },
    goDashboard() {
      this.$router.push({ name: process.env.VUE_APP_DASHBOARD }).then()
    },
  },
})
